import { lazyPage } from './lazyPage';
import type { AppRoute } from './types';

const ModuleMenu = lazyPage(() => import('@/pages/ModuleMenu'));
const ExaminationDashboard = lazyPage(() => import('@/pages/examination/Dashboard'));
const ExamSetup = lazyPage(() => import('@/pages/examination/ExamSetup'));
const ExamSubjects = lazyPage(() => import('@/pages/examination/ExamSubjects'));
const ExamSchedule = lazyPage(() => import('@/pages/examination/ExamSchedule'));
const QuestionPapers = lazyPage(() => import('@/pages/examination/QuestionPapers'));
const ExamAttendance = lazyPage(() => import('@/pages/examination/ExamAttendance'));
const EnterExamMarks = lazyPage(() => import('@/pages/examination/EnterExamMarks'));
const ExamGrading = lazyPage(() => import('@/pages/examination/ExamGrading'));
const ExamResults = lazyPage(() => import('@/pages/examination/ExamResults'));
const Toppers = lazyPage(() => import('@/pages/examination/Toppers'));
const ReportCards = lazyPage(() => import('@/pages/examination/ReportCards'));
const Transcripts = lazyPage(() => import('@/pages/examination/Transcripts'));
const Revaluation = lazyPage(() => import('@/pages/examination/Revaluation'));
const ExaminationReports = lazyPage(() => import('@/pages/examination/Reports'));

export const examinationRoutes: AppRoute[] = [
  {
    path: 'examination',
    title: 'Examination',
    children: [
      { path: '', title: 'Examination', component: ModuleMenu },
      {
        path: 'dashboard',
        title: 'Dashboard',
        component: ExaminationDashboard,
      },
      {
        path: 'exam-types',
        title: 'Exam Setup',
        redirectTo: '/administrator/examination/exams?tab=types',
      },
      {
        path: 'exams',
        title: 'Exam Setup',
        component: ExamSetup,
      },
      {
        path: 'subjects',
        title: 'Exam Subjects',
        component: ExamSubjects,
      },
      {
        path: 'schedule',
        title: 'Exam Schedule',
        component: ExamSchedule,
      },
      {
        path: 'question-papers',
        title: 'Question Papers',
        component: QuestionPapers,
      },
      {
        path: 'attendance',
        title: 'Exam Attendance',
        component: ExamAttendance,
      },
      {
        path: 'marks',
        title: 'Enter Marks',
        component: EnterExamMarks,
      },
      {
        path: 'grading',
        title: 'Grading',
        component: ExamGrading,
      },
      {
        path: 'results',
        title: 'Results',
        component: ExamResults,
      },
      {
        path: 'toppers',
        title: 'Toppers',
        component: Toppers,
      },
      {
        path: 'report-cards',
        title: 'Report Cards',
        component: ReportCards,
      },
      {
        path: 'transcripts',
        title: 'Transcripts',
        component: Transcripts,
      },
      {
        path: 'revaluation',
        title: 'Revaluation',
        component: Revaluation,
      },
      {
        path: 'reports',
        title: 'Examination Reports',
        component: ExaminationReports,
      },
    ],
  },
];
